import { useQuery } from "react-query";

import { newsletterThemeTemplateQueryKeys } from "./queryKeys";
import useApiHelper from "../../services/useApiHelper";
import { INewsletterThemeTemplate } from "../../models/newsletterThemeTemplate/NewsletterThemeTemplate";
import { IDefaultResponseWithData } from "../../models/system/DefaultResponse";

export function useNewsletterThemeSections(themeId?: string) {
  const { get } = useApiHelper();

  const sections = useQuery({
    queryKey: newsletterThemeTemplateQueryKeys.byThemeId(themeId ?? ""),
    queryFn: () =>
      get(
        `/emailtemplate/newsletter/${themeId}/sections`
      ) as unknown as IDefaultResponseWithData<INewsletterThemeTemplate[]>,
    refetchOnWindowFocus: false,
    enabled: !!themeId,
  });

  return {
    sections,
  };
}

